import axios from "axios";
const API_HOST = process.env.REACT_APP_API_HOST;

class Transaction_Service {
  getActiveBank(user, serach) {
    const noSpacesSerach = serach?.replace(/\s+/g, "");
    return axios({
      method: "get",
      url: `${API_HOST}/api/get-Active-bank?search=${noSpacesSerach}`,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

  getActiveWebsite(user, serach) {
    const noSpacesSerach = serach?.replace(/\s+/g, "");
    return axios({
      method: "get",
      url: `${API_HOST}/api/get-Active-website?search=${noSpacesSerach}`,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

  getCustomerName(user, serach) {
    const noSpacesSerach = serach?.replace(/\s+/g, "");
    return axios({
      method: "get",
      url: `${API_HOST}/api/get-customer?search=${noSpacesSerach}`,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

  createTransaction(user, payload) {
    return axios({
      method: "post",
      url: `${API_HOST}/api/admin/create/transaction`,
      data: payload,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

  allTransactionreport(user  , data, page , limit) {
    return axios({
      method: "post",
      url: `${API_HOST}/api/admin/account-summary?page=${page}&pageSize=${limit}`,
      data: {filters : data},
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }


  subadminWiseTxn(username, user, data, page , limit) {
    return axios({
      method: "post",
      url: `${API_HOST}/api/view-subadmin-transaction/${username}?page=${page}&pageSize=${limit}`,
      data:  {filters : data},
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

    getTransactionDeleteRequest(user , page , limit) {
    return axios({
      method: "get",
      url: `${API_HOST}/api/admin/view-Delete-Request/?page=${page}&pageSize=${limit}`,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

    getIntroducerTransaction(user , page , limit) {
    return axios({
      method: "get",
      url: `${API_HOST}/api/superadmin/view-edit-introducer-transaction-requests`,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }


    rejectTransactionDelete(id, user) {
    return axios({
      method: "delete",
      url: `${API_HOST}/api/reject/DeleteRequest/${id}`,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

    transactionMoveToTrash(id, user) {
    return axios({
      method: "post",
      url: `${API_HOST}/api/delete-transaction/${id}`,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

    websiteTransactionMoveToTrash(id, user) {
    return axios({
      method: "post",
      url: `${API_HOST}/api/delete-website-transaction/${id}`,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

   bankTransactionMoveToTrash(id, user) {
    return axios({
      method: "post",
      url: `${API_HOST}/api/delete-bank-transaction/${id}`,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

}

export default new Transaction_Service();
